import type { OverviewBatch } from "./journey-overview";

export type ExecutionStatusFilter =
  | "all"
  | "pending_confirm"
  | "upcoming"
  | "failed"
  | "voided"
  | "sent"
  | "cancelled";

export function parseExecutionStatus(raw: string | null): ExecutionStatusFilter {
  const allowed: ExecutionStatusFilter[] = [
    "pending_confirm",
    "upcoming",
    "failed",
    "voided",
    "sent",
    "cancelled",
  ];
  if (raw && (allowed as string[]).includes(raw)) return raw as ExecutionStatusFilter;
  return "all";
}

export function filterExecutionBatches(
  batches: OverviewBatch[],
  status: ExecutionStatusFilter,
): OverviewBatch[] {
  if (status === "all" || status === "upcoming") return batches;
  if (status === "voided") {
    return batches.filter((b) => b.status === "voided" || b.reason_code === "voided");
  }
  if (status === "cancelled") {
    return batches.filter((b) => b.status === "cancelled");
  }
  return batches.filter((b) => b.status === status);
}

export function filterExecutionLedger(
  batches: OverviewBatch[],
  opts: {
    status: ExecutionStatusFilter;
    journeyId?: number | null;
    from?: string;
    to?: string;
  },
): OverviewBatch[] {
  let list = filterExecutionBatches(batches, opts.status);
  if (opts.journeyId != null) {
    list = list.filter((b) => b.journey_definition_id === opts.journeyId);
  }
  if (opts.from) {
    list = list.filter((b) => b.day >= opts.from!);
  }
  if (opts.to) {
    list = list.filter((b) => b.day <= opts.to!);
  }
  return list;
}

export function localIsoDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function defaultExecutionRange(now: Date = new Date()): { from: string; to: string } {
  const to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const from = new Date(to);
  from.setDate(from.getDate() - 13);
  return { from: localIsoDate(from), to: localIsoDate(to) };
}
